//定义懒加载插件
import {useIntersectionObserver} from '@vueuse/core'
import { install } from 'element-plus'


export const LazyLoad = {
    install(app) {
        app.directive('lazy-load', {
            mounted(el, binding) {
                const {stop} = useIntersectionObserver(
                    el,
                    ([{isIntersecting}]) => {
                        if (isIntersecting) {
                            useIntersectionObserver(el, () => {
                                el.src = binding.value
                                stop()
                            })
                        }
                    }
                )
            }
        })
    }
}